@let compatibleError$ = compatibleError();

@if (error) {
  <mbs-alert
    class="mb-4"
    [icon]="true"
    [type]="mbsPopupType.danger"
    >{{ error }}</mbs-alert
  >
}

@if (compatibleError$) {
  <mbs-alert
    class="mb-4"
    [icon]="true"
    [type]="mbsPopupType.danger">
    <span>{{ compatibleError$.text }}</span>
    @if (compatibleError$.type === checkerError.NotCompatible) {
      <a
        class="ml-1"
        target="_blank"
        [helpLink]="'/billing-storage/storage-providers/s3compatible/s3-supported-storage'">
        {{ 'shared:buttons.learnMore' | i18next }}
      </a>
    }

    @if (compatibleError$.type === checkerError.Timeout) {
      <a
        class="ml-1"
        href="'/'"
        (click)="$event.preventDefault(); tryAgain.emit()">
        {{ 'shared:common.tryAgain' | i18next }}
      </a>

      <span class="ml-1">or</span>

      <a
        class="ml-1"
        href="'/'"
        (click)="$event.preventDefault(); reportIssue.emit()">
        {{ 'shared:buttons.reportIssue' | i18next: { format: 'lowercase' } }}
      </a>
    }

    @if (compatibleError$.type === checkerError.Unknown) {
      <a
        class="ml-1"
        href="'/'"
        (click)="$event.preventDefault(); reportIssue.emit()">
        {{ 'shared:buttons.reportIssue' | i18next }}
      </a>
    }
  </mbs-alert>
}

@if (alternateFormStorageTypes.includes(storageAccount?.storageType)) {
  <mbs-add-destination-alternate-form
    [companiesLocked]="companiesLocked"
    [form]="form"
    [hideCompanies]="hideCompanies"
    [selectedCompanyIds]="selectedCompanyIds"
    [storageAccount]="storageAccount"
    [viewMode]="'wizard'">
  </mbs-add-destination-alternate-form>
} @else {
  <mbs-add-destination-form
    [bucketTypeName]="bucketTypeName"
    [companiesLocked]="companiesLocked"
    [createNew]="createNew"
    [form]="form"
    [hideCompanies]="hideCompanies"
    [isDraftAccount]="isDraftAccount"
    [selectedCompanyIds]="selectedCompanyIds"
    [storageAccount]="storageAccount"
    [viewMode]="'wizard'"
    (bucketLoadingChanged)="bucketLoadingChanged.emit($event)"
    (criticalError)="error = $event"
    (currentBucketChanged)="currentBucketChanged.emit($event)">
  </mbs-add-destination-form>
}
